module.exports = __webpack_public_path__ + "img/banner(1).673b965e.jpg";